import styled from 'styled-components';
import {
  ICommentInput,
  IConversationThreadFieldsFragment,
} from '../../../../utils/apollo/graphqlSchema';
import useUser from '../../../../utils/hooks/useUser';
import useAddThreadComment from '../../hooks/useAddThreadComment';
import Avatar from '../../../Avatar';
import ConversationInput from '../../ConversationInput';
import { ICommentInputInfo } from '../../types';

interface IProps {
  thread: IConversationThreadFieldsFragment;
  onSubmit: (commentInputInfo: ICommentInputInfo) => void;
}

const Container = styled.div`
  display: flex;
  column-gap: 4px;
  padding: 8px 12px;
`;

const EntityConversationThreadInput = ({ thread, onSubmit }: IProps) => {
  const { id, entity, participants } = thread;

  const user = useUser();
  const addThreadComment = useAddThreadComment(entity, id);

  const handleSubmitComment = async (
    commentInput: ICommentInput,
    commentInputInfo: ICommentInputInfo,
  ) => {
    await addThreadComment(commentInput);
    onSubmit(commentInputInfo);
  };

  return (
    <Container>
      <Avatar picture={user.picture} size={16} />
      <ConversationInput
        onSubmit={handleSubmitComment}
        participants={participants}
        isUpdate={false}
      />
    </Container>
  );
};

export default EntityConversationThreadInput;
